const getAddressFromStopKey = (key) => {
  const addressKeyFromKey = {
    pickup: 'address_from',
    dropoff: 'address_to',
  };

  return addressKeyFromKey[key] || false;
};

export default getAddressFromStopKey;
